import { useCallback, useState } from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  useTheme,
} from '@mui/material';
import { HelpOutline, ErrorOutline } from '@mui/icons-material';
import { analytics, events } from 'services/analytics';
import { aiMusicGeneratorAwsApi } from 'services/api/aiMusicGenerator/aiMusicGeneratorApi';
import InfoGuideContent from './components/InfoGuideContent';

const InfoGuide = () => {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  const {
    data = null,
    error,
    isLoading: loading,
  } = aiMusicGeneratorAwsApi.useGetInfoGuideQuery();

  const handleOpenDialog = useCallback(() => {
    if (loading || error) {
      return;
    }
    setOpen(!open);
    analytics.track(events.infoGuideClick());
  }, [error, loading, open]);

  const displayIcon = useCallback(() => {
    if (error) {
      return <ErrorOutline />;
    }
    if (loading) {
      return <CircularProgress color="primary" size={20} />;
    }
    return <HelpOutline />;
  }, [loading, error]);

  return (
    <>
      <Dialog
        open={open}
        disableEnforceFocus
        maxWidth="lg"
        sx={{
          '& .MuiPaper-root': {
            borderRadius: '8px',
            overflowY: 'hidden',
          },
        }}
      >
        <InfoGuideContent data={data} open={open} setOpen={setOpen} />
      </Dialog>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[900],
        }}
      >
        <IconButton
          sx={{
            width: theme.spacing(5),
            height: theme.spacing(5),
            color: theme.palette.grey[50],
            backgroundColor: theme.palette.grey[700],
          }}
          size="small"
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleOpenDialog}
        >
          {displayIcon()}
        </IconButton>
      </Box>
    </>
  );
};

export default InfoGuide;
